import { create } from 'zustand';

export const useMaintenanceStore = create((set) => ({
  isUnderMaintenance: false, // set to true to turn on maintenance mode
  setMaintenanceMode: (value) => set({ isUnderMaintenance: value }),
})); 